export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/arcgis.791761a.svg";